<template>
  <status-select :options="options" :record="record" record_type="transfer" />
</template>

<script>
  import { transferStatuses } from 'shared/statuses'
  import StatusSelect from '../../shared/components/status-select'
  export default {
    props: [ 'record' ],
    data () {
      return { options: transferStatuses }
    },
    components: {
      StatusSelect
    }
  }
</script>
